import React, { useReducer }  from 'react';
import BCMSDispatcher from "../../classes/BCMSDispatcher";
import { useBCMSContext } from '../../index.jsx';

// Creates context for managing state:
const BCMSControllerContext = React.createContext(null);
const BCMSGlobalControllerContext = React.createContext(null);

// :: STATE, (STATE, ACTION) -> STATE
// Define main component:

export default function BCMSController ({initState, dispatcher, children}) {
  dispatcher = dispatcher == undefined ? new BCMSDispatcher() : dispatcher;

  if(!(dispatcher instanceof BCMSDispatcher)){
    throw new Error("Dispatcher passed to the controller is not an instance of BCMSDispatcher");
  }

  const [ get, dispatch ] = useReducer(dispatcher.generate(), initState || {});
  const dispatcherFN = (type, payload) => dispatch({ type, payload });

  return (
    <BCMSControllerContext.Provider value={{ "state": get, "dispatcher": dispatcherFN }}>
      {children}
    </BCMSControllerContext.Provider>
  );
}

// Custom hook for accessing controller:
export const useBCMSController = () => React.useContext(BCMSControllerContext);

// BCMSGlobalContext :: Wrapper for the demo to maintain an easy way to access the global controller
// state and dispatcher.
export function BCMSGlobalContext(props){
  const { state, dispatcher } = useBCMSController();

  return (
    <BCMSGlobalControllerContext.Provider value={ { state, dispatcher } }>
      { props.children }
    </BCMSGlobalControllerContext.Provider>
  );
}

// Custom hook for accessing the global controller
export const useBCMSGlobalController = () => React.useContext(BCMSGlobalControllerContext);